export enum PatientType {
  Employee = 'employee',
  Blocked = 'blocked',
}
